import React, { useEffect, useState, useRef } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { secretKey, monthData } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import AddSellFile from "./add_sellFile.js";
import AddAggr from "./addAggr.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddSellClientContactPopUp from "./addSellClientContact_popup.js";
import SendSellClientMail from "./sendSellClientMail.js";
import SendSellClientSMS from "./sendSellClientSMS.js";
import ClientContactPopUp from "./client_contact_popup.js";
import AddLeadNote from "./addLeadNote.js";
import AddSellTask from "./addSellTask.js";
import AddLeadNoteSmall from "./addLeadNoteSmall.js";
import EditLeadName from "./editLeadName.js";
import EditLeadPhone from "./editLeadPhone.js";
import EditLeadMail from "./editLeadMail.js";
import EditLeadBank from "./editLeadBank.js";
import EditLeadOwner from "./editLeadOwner.js";
import EditLeadSupport from "./editLeadSupport.js";
import EditLeadStatus from "./editLeadStatus.js";
import EditLeadCreditData from "./editLeadCreditData.js";
import SellGenerateAnalysis from "./sellGenerateAnalysis.js";
import { faEdit, faEye, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SellTaskPopUp from "./sellTask_popup.js";
import EditLeadType from "./editLeadType";
import NotePopUp from "./note_popup.js";
import AddClient from "./addClient_popup.js";
import emailjs from "@emailjs/browser";
import FinishLeadFirst from "./finishLeadFirst.js";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
import EditLeadSource from "./editLeadSource.js";
import EditLeadRealSource from "./editLeadSource.js";
import EditLeadFut from "./editLeadFut";
import AnSKD from "./anSKD";
import EditLeadSupportLawyer from "./editLeadSupportLawyer";
import EditLeadDecAgg from "./editLeadDecAgg";

const MySwal = withReactContent(Swal2);

const zip = new JSZip();

const LeadPopUp = (props) => {
  const [tabIndex, setTabIndex] = useState(
    props.tabIndex === undefined ? 0 : props.tabIndex
  );
  const [sellTasks, setSellTasks] = useState([]);
  const [sellLogs, setSellLogs] = useState([]);
  const [docMode, setDocMode] = useState("cat");
  const [docSort, setDocSord] = useState("down");
  const [sellFiles, setSellFiles] = useState([]);
  const [sellFilesOri, setSellFilesOri] = useState([]);
  const [sellContacts, setSellContacts] = useState([]);
  const [sellNote, setSellNote] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddFile, setShowAddFile] = useState(false);
  const [showAddClientContact, setShowAddClientContact] = useState(false);
  const [showSendClientMail, setShowSendClientMail] = useState(false);
  const [showSendClientSMS, setShowSendClientSMS] = useState(false);
  const [showClientContact, setShowClientContact] = useState(false);
  const [showAddLeadNote, setShowAddLeadNote] = useState(false);
  const [showEditLeadName, setShowEditLeadName] = useState(false);
  const [showEditLeadPhone, setShowEditLeadPhone] = useState(false);
  const [showEditLeadMail, setShowEditLeadMail] = useState(false);
  const [showEditLeadType, setShowEditLeadType] = useState(false);
  const [showEditLeadBank, setShowEditLeadBank] = useState(false);
  const [showEditLeadSource, setShowEditLeadSource] = useState(false);
  const [showEditLeadRealSource, setShowEditLeadRealSource] = useState(false);
  const [showEditLeadOwner, setShowEditLeadOwner] = useState(false);
  const [showEditLeadSupport, setShowEditLeadSupport] = useState(false);
  const [showEditLeadStatus, setShowEditLeadStatus] = useState(false);
  const [showEditLeadFut, setShowEditLeadFut] = useState(false);
  const [showEditLeadDecAgg, setShowEditLeadDecAgg] = useState(false);
  const [showEditLeadTask, setShowEditLeadTask] = useState(false);
  const [showTaskPopUp, setShowTaskPopUp] = useState(false);
  const [showTaskPopUpId, setShowTaskPopUpId] = useState(false);
  const [showSellGenerateAnalysis, setShowSellGenerateAnalysis] =
    useState(false);
  const [logUserFilter, setLogUserFilter] = useState("all");
  const [logUsers, setLogUsers] = useState([]);
  const [noteContent, setNoteContent] = useState("");
  const [analysis, setAnalysis] = useState([]);
  const [lead, setLead] = useState(false);
  const [showEditLeadCreditData, setShowEditLeadCreditData] = useState(false);
  const [contactId, setContactId] = useState(false);
  const [users, setUsers] = useState([]);
  const [leadAdditionalData, setLeadAdditionalData] = useState([]);
  const [showNotePopUp, setShowNotePopUp] = useState(false);
  const [showAddClient, setShowAddClient] = useState(false);
  const [editOption, setEditOption] = useState("all");
  const [lawyersData, setLawyersData] = useState([]);
  const [courtsData, setCourtsData] = useState([]);
  const [banksData, setBanksData] = useState([]);
  const [showFinishLead, setShowFinishLead] = useState(false);
  const [showAddAggr, setShowAddAggr] = useState(false);
  const [showSkdAn, setShowSkdAn] = useState(false);
  const [showLeadSupportLawyer, setShowLeadSupportLawyer] = useState(false);

  const showClientContactPopUp = (e) => {
    setContactId(e.target.value);
    setShowClientContact(true);
  };

  const showFinishLeadData = (e) => {
    setShowFinishLead(true);
  };

  const closeFinishLeadData = (e) => {
    setShowFinishLead(false);
    getData();
  };

  const showLeadFut = (e) => {
    setShowEditLeadFut(true);
  };

  const closeLeadFut = (e) => {
    setShowEditLeadFut(false);
    getData();
  };

  const showLeadDecAgg = (e) => {
    setShowEditLeadDecAgg(true);
  };

  const closeLeadDecAgg = (e) => {
    setShowEditLeadDecAgg(false);
    getData();
  };

  const closeFinishLeadDataS = (e) => {
    MySwal.fire({
      icon: "success",
      title: "Sprawa",
      text: "została przekazana do założenia",
    }).then(async (result) => {
      setShowFinishLead(false);
      getData();
    });
  };

  const handleShowSendFile = (e) => {
    setShowAddFile(true);
  };

  const closeSendFile = (e) => {
    setShowAddFile(false);
    getData();
  };

  const handleShowAddAggr = (e) => {
    setShowAddAggr(true);
  };

  const handleShowSkdAn = (e) => {
    setShowSkdAn(true);
  };

  const closeAddAggr = (e) => {
    setShowAddAggr(false);
    getData();
  };

  const closeAddSkdAn = (e) => {
    setShowSkdAn(false);
    getData();
  };

  const handleShowAddTask = (e) => {
    setShowEditLeadTask(true);
  };

  const closeAddTask = (e) => {
    setShowEditLeadTask(false);
    getData();
  };

  const handleShowNote = (e) => {
    setNoteContent(e.currentTarget.value);
    setShowNotePopUp(true);
  };

  const handleCloseNote = (e) => {
    setNoteContent("");
    setShowNotePopUp(false);
  };

  const handleShowAddLeadNote = (e) => {
    setShowAddLeadNote(true);
  };

  const closeAddLeadNote = (e) => {
    setShowAddLeadNote(false);
    getData();
  };

  const getInitials = (user) => {
    var newData = users.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const handleShowEditLeadType = (e) => {
    setShowEditLeadType(true);
  };

  const closeEditLeadType = (e) => {
    setShowEditLeadType(false);
    getData();
  };

  const handleShowTaskPopUp = (e) => {
    setShowTaskPopUp(true);
    setShowTaskPopUpId(e.target.value);
  };

  const closeShowTaskPopUp = (e) => {
    setShowTaskPopUp(false);
    setShowTaskPopUpId("");
    getData();
  };

  const handleShowEditLeadName = (e) => {
    setShowEditLeadName(true);
  };

  const closeEditLeadName = (e) => {
    setShowEditLeadName(false);
    getData();
  };

  const handleShowEditLeadSource = (e) => {
    setShowEditLeadSource(true);
  };

  const closeEditLeadRealSource = (e) => {
    setShowEditLeadRealSource(false);
    getData();
  };

  const handleShowEditLeadRealSource = (e) => {
    setShowEditLeadRealSource(true);
  };

  const closeEditLeadSource = (e) => {
    setShowEditLeadSource(false);
    getData();
  };

  const handleShowGenerateAnalysis = (e) => {
    setShowSellGenerateAnalysis(true);
  };

  const closeGenerateAnalysis = (e) => {
    setShowSellGenerateAnalysis(false);
    getData();
  };

  const handleShowEditLeadPhone = (e) => {
    setShowEditLeadPhone(true);
  };

  const closeEditLeadPhone = (e) => {
    setShowEditLeadPhone(false);
    getData();
  };

  const handleShowEditLeadMail = (e) => {
    setShowEditLeadMail(true);
  };

  const closeEditLeadMail = (e) => {
    setShowEditLeadMail(false);
    getData();
  };

  const handleShowEditLeadBank = (e) => {
    setShowEditLeadBank(true);
  };

  const closeEditLeadBank = (e) => {
    setShowEditLeadBank(false);
    getData();
  };

  const handleShowEditLeadCreditData = (e) => {
    setShowEditLeadCreditData(true);
  };

  const closeEditLeadCreditData = (e) => {
    setShowEditLeadCreditData(false);
    getData();
  };

  const handleShowEditLeadOwner = (e) => {
    setShowEditLeadOwner(true);
  };

  const closeEditLeadOwner = (e) => {
    setShowEditLeadOwner(false);
    getData();
  };

  const handleShowEditLeadSupport = (e) => {
    setShowEditLeadSupport(true);
  };

  const closeEditLeadSupport = (e) => {
    setShowEditLeadSupport(false);
    getData();
  };

  const closeEditLeadSupportLawyer = (e) => {
    setShowLeadSupportLawyer(false);
    getData();
  };

  const handleShowEditLeadStatus = (e) => {
    setShowEditLeadStatus(true);
  };

  const closeEditLeadStatus = (e) => {
    setShowEditLeadStatus(false);
    getData();
  };

  const closeEditLeadStatusFull = (e) => {
    setShowEditLeadStatus(false);
    props.close();
  };

  const fetchLead = async () => {
    var body = {
      id: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLead(data[0]);
        if (
          data[0].aggAdditionalData !== null &&
          data[0].aggAdditionalData !== undefined &&
          data[0].aggAdditionalData !== ""
        ) {
          var arr = data[0].aggAdditionalData.split("|");
          arr.pop();
          var arr2 = [];
          arr.map((el) => {
            var x = el.split(",");
            arr2.push({ name: x[0], pesel: x[1], address: x[2] });
          });
          setLeadAdditionalData(arr2);
        }
        setTimeout(() => {
          setLoading(false);
        }, 500);
        fetchTasks(data[0]);
      })
      .catch((error) => {});
  };

  const fetchTasks = async (lead) => {
    var body = {
      id: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellTasksForLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellTasks(data);
        fetchLogs(lead);
      })
      .catch((error) => {});
  };

  const fetchLogs = async (lead) => {
    var body = {
      id: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellLogsForLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var users = [];
        data.map((el) => {
          if (users.filter((e) => e === el.employee).length === 0) {
            users.push(el.employee);
          }
        });
        setLogUsers(users);
        setSellLogs(data);
        fetchLawyers(lead);
      })
      .catch((error) => {});
  };

  const fetchLawyers = async (lead) => {
    var body = {
      id: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawyersData(data);
        fetchCourts(lead);
      })
      .catch((error) => {});
  };

  const fetchCourts = async (lead) => {
    var body = {
      id: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getCourts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCourtsData(data);
        fetchBanks(lead);
      })
      .catch((error) => {});
  };

  const fetchBanks = async (lead) => {
    var body = {
      id: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanksData(data);
        fetchFiles(lead);
      })
      .catch((error) => {});
  };

  const fetchFiles = async (lead) => {
    var body = {
      leadId: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellFilesLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellFiles(
          data.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
        );
        setSellFilesOri(
          data.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
        );
        fetchContacts(lead);
      })
      .catch((error) => {});
  };

  const fetchContacts = async (lead) => {
    var body = {
      leadId: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellClientsContacts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellContacts(data);
        fetchNotes(lead);
      })
      .catch((error) => {});
  };

  const fetchNotes = async (lead) => {
    var body = {
      leadId: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellNote", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellNote(data);
        fetchAnalysis(lead);
      })
      .catch((error) => {});
  };

  const fetchAnalysis = async (lead) => {
    var body = {
      leadId: props.lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getAnalysis", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAnalysis(data);
        fetchUsers(lead);
      })
      .catch((error) => {});
  };

  const fetchAnalysis2 = (lead) => {
    var body = {
      leadId: props.lead.id,
    };

    fetch("https://apidevkppp.ftpeople.pl/getAnalysis", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAnalysis(data);
      })
      .catch((error) => {});
    return;
  };

  const fetchUsers = async (lead) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        if (
          data.filter((el) => el.name === lead.owner)[0].role ===
            "consultantTele" &&
          lead.support === props.user.name
        ) {
          setShowLeadSupportLawyer(true);
        }
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setLoading(true);
    props.logLeadAction("Otwarto kartę leada", props.lead.id);
    await fetchLead();
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const asd = setInterval(() => {
      //fetchAnalysis2(lead.id);
    }, 50);

    return () => clearInterval(asd);
  });

  const getPesel = (name) => {
    var pesel = "";
    leadAdditionalData.map((el) => {
      if (el.name.replaceAll(" ", "") === name.replaceAll(" ", "")) {
        pesel = el.pesel;
      }
    });
    return pesel;
  };

  const getAddress = (name) => {
    var address = "";
    leadAdditionalData.map((el) => {
      if (el.name.replaceAll(" ", "") === name.replaceAll(" ", "")) {
        address = el.address;
      }
    });
    return address.replaceAll(";", ",");
  };

  const clearLeadSupport = async (e) => {
    setLoading(true);

    var body = {
      leadId: props.lead.id,
      status: props.lead.status,
      leadName: props.lead.name,
      field: "support",
      value: "",
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        props.close();
      })
      .catch((error) => {});
  };

  const leadData = (
    <>
      {!lead ? (
        ""
      ) : (
        <table id="detailClientTable" className="clients_table">
          <>
            <tr>
              <td>ID</td>
              <td>{lead.id} </td>
              <td></td>
            </tr>
            <tr>
              <td>Imię i nazwisko</td>
              <td>
                {lead.aggAdditionalData ? (
                  <>
                    <table
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      {lead.name.split(",").map((el) => (
                        <>
                          <tr style={{ backgroundColor: "transparent" }}>
                            <td
                              style={{
                                width: "30%",
                                backgroundColor: "transparent",
                                borderWidth: "0px 0px",
                                padding: "2px",
                              }}
                            >
                              {el}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                backgroundColor: "transparent",
                                borderWidth: "0px 1px",
                                padding: "2px",
                              }}
                            >
                              {getPesel(el)}
                            </td>
                            <td
                              style={{
                                width: "50%",
                                backgroundColor: "transparent",
                                borderWidth: "0px 0px",
                                padding: "2px",
                              }}
                            >
                              {getAddress(el)}
                            </td>
                          </tr>
                        </>
                      ))}
                    </table>
                  </>
                ) : (
                  lead.name
                )}
              </td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadName}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Numer telefonu</td>
              <td>{lead.phone}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadPhone}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Adres e-mail</td>
              <td>{lead.mail}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadMail}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Notatka</td>
              <td>
                {lead.note === "" ||
                lead.note === null ||
                lead.note === undefined
                  ? "brak danych"
                  : lead.note.substring(0, 185) + "..."}
              </td>
              <td>
                {props.view !== "client" ? (
                  <>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowAddLeadNote}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={lead.note}
                      onClick={handleShowNote}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Data dodania do systemu</td>
              <td>
                {new Date(lead.addDate).getFullYear() +
                  "-" +
                  (new Date(lead.addDate).getMonth() + 1 < 10
                    ? "0" + (new Date(lead.addDate).getMonth() + 1)
                    : new Date(lead.addDate).getMonth() + 1) +
                  "-" +
                  (new Date(lead.addDate).getDate() + 1 < 10
                    ? "0" + new Date(lead.addDate).getDate()
                    : new Date(lead.addDate).getDate()) +
                  " " +
                  (new Date(lead.addDate).getHours() < 10
                    ? "0" + new Date(lead.addDate).getHours()
                    : new Date(lead.addDate).getHours()) +
                  ":" +
                  (new Date(lead.addDate).getMinutes() < 10
                    ? "0" + new Date(lead.addDate).getMinutes()
                    : new Date(lead.addDate).getMinutes())}
              </td>
              <td></td>
            </tr>
            <tr>
              <td>Rodzaj</td>
              <td>{lead.type}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadType}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Bank</td>
              <td>{lead.bank}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadBank}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Źródło</td>
              <td>{lead.source}</td>
              <td>
                {props.user.adminSprzedaz === "1" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadSource}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            {props.user.salesSuperAdmin === "1" ? (
              <tr>
                <td>Źródło - oryginał</td>
                <td>{lead.realSource}</td>
                <td>
                  {" "}
                  {props.user.adminSprzedaz === "1" ? (
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowEditLeadRealSource}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            ) : (
              ""
            )}
            <tr>
              <td>Opiekun</td>
              <td>
                {lead.owner === "" || lead.owner === null
                  ? "brak danych"
                  : lead.owner}
              </td>
              <td>
                {props.view !== "client" ? (
                  props.user.adminSprzedaz === "1" ? (
                    <>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="name"
                        onClick={handleShowEditLeadOwner}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Wsparcie</td>
              <td>
                {lead.support === "" || lead.support === null
                  ? "brak danych"
                  : lead.support}
              </td>
              <td>
                {props.view !== "client" ? (
                  props.user.adminSprzedaz === "1" ||
                  props.user.name === lead.owner ? (
                    <>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="name"
                        onClick={handleShowEditLeadSupport}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </>
                  ) : props.user.adminSprzedaz !== "1" ||
                    props.user.name !== lead.owner ? (
                    <>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="name"
                        onClick={clearLeadSupport}
                      >
                        <FontAwesomeIcon icon={faClose} />
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </td>
            </tr>

            {(lead.recArr ? lead.recArr.length > 5 : false) ? (
              <>
                <tr>
                  <td>Wsparcie - rekomendacje</td>
                  <td style={{ padding: "10px" }}>
                    {JSON.parse(lead.recArr.replace(/\t/g, " "))
                      .sort(function (a, b) {
                        return new Date(b.date) - new Date(a.date);
                      })
                      .map((el, index) => (
                        <div style={{ textAlign: "left" }}>
                          <p>
                            {el.date}, {el.support}, {el.topic}, wynik:
                            {el.recommendation}
                          </p>
                          <p> Notatka: {el.recommendation_note}</p>
                          {index + 1 <
                          JSON.parse(lead.recArr.replace(/\t/g, " ")).length ? (
                            <hr></hr>
                          ) : (
                            ""
                          )}
                        </div>
                      ))}
                  </td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}

            <tr>
              <td>Status</td>
              <td>{lead.status}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadStatus}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            {lead.status === "mamy podpisaną umowę o współpracę" &&
            lead.dateMarkFinish !== "" &&
            lead.dateMarkFinish !== null ? (
              <>
                <tr>
                  <td>Data zlecenia założenia sprawy</td>
                  <td>
                    {lead.dateMarkFinish === "" || lead.dateMarkFinish === null
                      ? ""
                      : new Date(lead.dateMarkFinish).getFullYear() +
                        "-" +
                        (new Date(lead.dateMarkFinish).getMonth() + 1 < 10
                          ? "0" + (new Date(lead.dateMarkFinish).getMonth() + 1)
                          : new Date(lead.dateMarkFinish).getMonth() + 1) +
                        "-" +
                        (new Date(lead.dateMarkFinish).getDate() + 1 < 10
                          ? "0" + new Date(lead.dateMarkFinish).getDate()
                          : new Date(lead.dateMarkFinish).getDate()) +
                        " " +
                        (new Date(lead.dateMarkFinish).getHours() < 10
                          ? "0" + new Date(lead.dateMarkFinish).getHours()
                          : new Date(lead.dateMarkFinish).getHours()) +
                        ":" +
                        (new Date(lead.dateMarkFinish).getMinutes() < 10
                          ? "0" + new Date(lead.dateMarkFinish).getMinutes()
                          : new Date(lead.dateMarkFinish).getMinutes())}
                  </td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}
            <tr>
              <td>Kontakt rokujący</td>
              <td>{lead.fut ? lead.fut : "brak danych"}</td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="name"
                  onClick={showLeadFut}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
            <tr>
              <td>Deklaracja przesłania umowy</td>
              <td>{lead.decAgg ? lead.decAgg : "brak danych"}</td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="name"
                  onClick={showLeadDecAgg}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>

            {lead.status === "oznaczono do zamknięcia" ? (
              <>
                <tr>
                  <td>Przyczyna zamknięcia</td>
                  <td>{lead.cancelReason}</td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}
            {lead.aggBankNext ? (
              <>
                <tr>
                  <td>Podmiot z umowy kredytowej</td>
                  <td>{lead.aggBankNext}</td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}
            {lead.aggCreditNumber ? (
              <>
                <tr>
                  <td>Numer umowy kredytowej</td>
                  <td>{lead.aggCreditNumber}</td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}
            {lead.skd_ank === "1" ? (
              <>
                <tr>
                  <td>Czy kredyt/pożyczka jest już spłacony?</td>
                  <td>{lead.skd_spl ? lead.skd_spl : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
                {lead.skd_spl ? (
                  <>
                    <tr>
                      <td>Kiedy nastąpiła całkowita spłata?</td>
                      <td>
                        {lead.skd_date_spl ? lead.skd_date_spl : "brak danych"}
                      </td>
                      <td>
                        <button
                          style={{
                            marginLeft: "10px",
                            width: "10%",
                            backgroundColor: "transparent",
                            color: "#a5bea4",
                            border: "none",
                            fontSize: "1vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value="name"
                          onClick={handleShowSkdAn}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </td>
                    </tr>
                  </>
                ) : (
                  ""
                )}

                <tr>
                  <td>
                    Czy w momencie zawierania umowy kredytu któryś z
                    kredytobiorców prowadził działalność gospodarczą?
                  </td>
                  <td>{lead.skd_dg ? lead.skd_dg : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
                {lead.skd_dg === "TAK" ? (
                  <>
                    <tr>
                      <td>
                        Dodatkowe informacje o działalności gospodarczej. Czy ma
                        Pan/Pani dokumenty (np. potwierdzenie przelewów, umowę
                        zakupu samochodu, rachunki za remont) które wykażą, że
                        te środki były przeznaczone dla Pana, rodziny – a nie na
                        firmę.
                      </td>
                      <td>
                        {lead.skd_dg_add ? lead.skd_dg_add : "brak danych"}
                      </td>
                      <td>
                        <button
                          style={{
                            marginLeft: "10px",
                            width: "10%",
                            backgroundColor: "transparent",
                            color: "#a5bea4",
                            border: "none",
                            fontSize: "1vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value="name"
                          onClick={handleShowSkdAn}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </td>
                    </tr>
                  </>
                ) : (
                  ""
                )}

                <tr>
                  <td>
                    Jaki jest to rodzaj kredytu/pożyczki (gotówkowy/hipoteczny)?
                  </td>
                  <td>{lead.skd_type ? lead.skd_type : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    Na co przeznaczyła Pan/Pani otrzymaną kwotę
                    pożyczki/kredytu?
                  </td>
                  <td>{lead.skd_q1 ? lead.skd_q1 : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    Czy kredyt/pożyczka została zaciągnięta w celu spłacenia
                    innych zobowiązań?
                  </td>
                  <td>{lead.skd_q2 ? lead.skd_q2 : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    Czy którykolwiek ze spłaconych wcześniejszych kredytów
                    został przeznaczony na działalność gospodarczą?
                  </td>
                  <td>{lead.skd_q3 ? lead.skd_q3 : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Czy ogłosił Pan/Pani upadłość konsumencką?</td>
                  <td>{lead.skd_q4 ? lead.skd_q4 : "brak danych"}</td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowSkdAn}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              </>
            ) : (
              ""
            )}
          </>
        </table>
      )}
    </>
  );

  const leadDataMobile = (
    <>
      {!lead ? (
        ""
      ) : (
        <table
          id="detailClientTable"
          className="clients_table"
          style={{ fontSize: "2vw" }}
        >
          <>
            <tr>
              <td>ID</td>
              <td>{lead.id} </td>
              <td></td>
            </tr>
            <tr>
              <td>Imię i nazwisko</td>
              <td>{lead.name} </td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadName}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Numer telefonu</td>
              <td>{lead.phone}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadPhone}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Adres e-mail</td>
              <td>{lead.mail}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadMail}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Notatka</td>
              <td>
                {lead.note === "" ||
                lead.note === null ||
                lead.note === undefined
                  ? "brak danych"
                  : lead.note.substring(0, 185) + "..."}
              </td>
              <td>
                {props.view !== "client" ? (
                  <>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowAddLeadNote}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={lead.note}
                      onClick={handleShowNote}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Data dodania do systemu</td>
              <td>
                {new Date(lead.addDate).getFullYear() +
                  "-" +
                  (new Date(lead.addDate).getMonth() + 1 < 10
                    ? "0" + (new Date(lead.addDate).getMonth() + 1)
                    : new Date(lead.addDate).getMonth() + 1) +
                  "-" +
                  (new Date(lead.addDate).getDate() + 1 < 10
                    ? "0" + new Date(lead.addDate).getDate()
                    : new Date(lead.addDate).getDate()) +
                  " " +
                  (new Date(lead.addDate).getHours() < 10
                    ? "0" + new Date(lead.addDate).getHours()
                    : new Date(lead.addDate).getHours()) +
                  ":" +
                  (new Date(lead.addDate).getMinutes() < 10
                    ? "0" + new Date(lead.addDate).getMinutes()
                    : new Date(lead.addDate).getMinutes())}
              </td>
              <td></td>
            </tr>
            <tr>
              <td>Rodzaj</td>
              <td>{lead.type}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadType}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Bank</td>
              <td>{lead.bank}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadBank}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Źródło</td>
              <td>{lead.source}</td>
              <td>
                {props.user.adminSprzedaz === "1" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadSource}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            {props.user.salesSuperAdmin === "1" ? (
              <tr>
                <td>Źródło - oryginał</td>
                <td>{lead.realSource}</td>
                <td>
                  {" "}
                  {props.user.adminSprzedaz === "1" ? (
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="name"
                      onClick={handleShowEditLeadRealSource}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            ) : (
              ""
            )}
            <tr>
              <td>Opiekun</td>
              <td>
                {lead.owner === "" || lead.owner === null
                  ? "brak danych"
                  : lead.owner}
              </td>
              <td>
                {props.view !== "client" ? (
                  props.user.adminSprzedaz === "1" ? (
                    <>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="name"
                        onClick={handleShowEditLeadOwner}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>{lead.status}</td>
              <td>
                {props.view !== "client" &&
                props.user.role !== "consultantTele" &&
                props.user.role !== "consultantTeleSKD" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadStatus}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            {lead.status === "mamy podpisaną umowę o współpracę" &&
            lead.dateMarkFinish !== "" &&
            lead.dateMarkFinish !== null ? (
              <>
                <tr>
                  <td>Data zlecenia założenia sprawy</td>
                  <td>
                    {lead.dateMarkFinish === "" || lead.dateMarkFinish === null
                      ? ""
                      : new Date(lead.dateMarkFinish).getFullYear() +
                        "-" +
                        (new Date(lead.dateMarkFinish).getMonth() + 1 < 10
                          ? "0" + (new Date(lead.dateMarkFinish).getMonth() + 1)
                          : new Date(lead.dateMarkFinish).getMonth() + 1) +
                        "-" +
                        (new Date(lead.dateMarkFinish).getDate() + 1 < 10
                          ? "0" + new Date(lead.dateMarkFinish).getDate()
                          : new Date(lead.dateMarkFinish).getDate()) +
                        " " +
                        (new Date(lead.dateMarkFinish).getHours() < 10
                          ? "0" + new Date(lead.dateMarkFinish).getHours()
                          : new Date(lead.dateMarkFinish).getHours()) +
                        ":" +
                        (new Date(lead.dateMarkFinish).getMinutes() < 10
                          ? "0" + new Date(lead.dateMarkFinish).getMinutes()
                          : new Date(lead.dateMarkFinish).getMinutes())}
                  </td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}
            <tr>
              <td>Kontakt rokujący</td>
              <td>{lead.fut ? lead.fut : "brak danych"}</td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="name"
                  onClick={showLeadFut}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
            {lead.status === "oznaczono do zamknięcia" ? (
              <>
                <tr>
                  <td>Przyczyna zamknięcia</td>
                  <td>{lead.cancelReason}</td>
                  <td></td>
                </tr>
              </>
            ) : (
              ""
            )}
          </>
        </table>
      )}
    </>
  );

  const sellContactData = (
    <>
      {sellContacts.length === 0 ? (
        <>Brak kontaktów z klientem dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data kontaktu
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Rodzaj kontaktu
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Treść
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Użytkownik
                </th>
                <th></th>
              </tr>
              {sellContacts
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate()) +
                          " " +
                          (new Date(el.date).getHours() < 10
                            ? "0" + new Date(el.date).getHours()
                            : new Date(el.date).getHours()) +
                          ":" +
                          (new Date(el.date).getMinutes() < 10
                            ? "0" + new Date(el.date).getMinutes()
                            : new Date(el.date).getMinutes())}
                      </td>
                      <td
                        style={{
                          width: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.type}
                      </td>
                      <td
                        style={{
                          width: "50%",
                          fontSize: "0.8vw",
                          height: "10vh",
                          padding: "5px 10px",
                        }}
                      >
                        {el.content.substring(0, 500)}
                      </td>
                      <td
                        style={{
                          width: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          padding: "5px 10px",
                        }}
                      >
                        {getInitials(el.user)}
                      </td>
                      <td style={{ width: "10%" }}>
                        <button
                          style={{
                            width: "80%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showClientContactPopUp}
                        >
                          {"Szczegóły kontaktu"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const sellContactDataMobile = (
    <>
      {sellContacts.length === 0 ? (
        <>Brak kontaktów z klientem dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px", fontSize: "2vw" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data kontaktu
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Rodzaj kontaktu
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Uż.
                </th>
                <th></th>
              </tr>
              {sellContacts
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate()) +
                          " " +
                          (new Date(el.date).getHours() < 10
                            ? "0" + new Date(el.date).getHours()
                            : new Date(el.date).getHours()) +
                          ":" +
                          (new Date(el.date).getMinutes() < 10
                            ? "0" + new Date(el.date).getMinutes()
                            : new Date(el.date).getMinutes())}
                      </td>
                      <td
                        style={{
                          width: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.type}
                      </td>
                      <td
                        style={{
                          width: "5%",
                          fontSize: "2vw",
                          height: "3vh",
                          padding: "5px 10px",
                        }}
                      >
                        {getInitials(el.user)}
                      </td>
                      <td style={{ width: "10%" }}>
                        <button
                          style={{
                            width: "80%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                            fontSize: "2vw",
                            padding: "5px 10px",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showClientContactPopUp}
                        >
                          {"Szczegóły kontaktu"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const creditData = (
    <>
      {!lead ? (
        ""
      ) : (
        <table id="detailClientTable" className="clients_table">
          <>
            <tr>
              <td>Bank</td>
              <td>{lead.bank}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadBank}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Kwota kredytu</td>
              <td>
                {numberWithCommas(lead.creditAmmount) +
                  " " +
                  lead.creditCurrency}
              </td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadCreditData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Data kredytu</td>
              <td>{lead.creditDate}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadCreditData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Okres kredytowania</td>
              <td>{lead.creditLength} miesięcy</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadCreditData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            {lead.creditEnd !== null && lead.creditEnd.length > 0 ? (
              <>
                <tr>
                  <td>Data zakończenia kredytu</td>
                  <td>{lead.creditEnd}</td>
                  <td>
                    {props.view !== "client" ? (
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="name"
                        onClick={handleShowEditLeadCreditData}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </>
            ) : (
              ""
            )}
          </>
        </table>
      )}
    </>
  );

  const creditDataMobile = (
    <>
      {!lead ? (
        ""
      ) : (
        <table
          id="detailClientTable"
          className="clients_table"
          style={{ fontSize: "2vw" }}
        >
          <>
            <tr>
              <td>Bank</td>
              <td>{lead.bank}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadBank}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Kwota kredytu</td>
              <td>
                {numberWithCommas(lead.creditAmmount) +
                  " " +
                  lead.creditCurrency}
              </td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadCreditData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Data kredytu</td>
              <td>{lead.creditDate}</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadCreditData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Okres kredytowania</td>
              <td>{lead.creditLength} miesięcy</td>
              <td>
                {props.view !== "client" ? (
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditLeadCreditData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
            {lead.creditEnd !== null && lead.creditEnd.length > 0 ? (
              <>
                <tr>
                  <td>Data zakończenia kredytu</td>
                  <td>{lead.creditEnd}</td>
                  <td>
                    {props.view !== "client" ? (
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="name"
                        onClick={handleShowEditLeadCreditData}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </>
            ) : (
              ""
            )}
          </>
        </table>
      )}
    </>
  );

  const taskData = (
    <>
      {sellTasks.length === 0 ? (
        <>Brak zadań dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Zadanie
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Prawnik
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data wprowadzenia
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data wykonania
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                ></th>
              </tr>

              {sellTasks
                .sort((a, b) => new Date(b.addDate) - new Date(a.addDate))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.task}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.responsible}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.startDate}
                      </td>
                      <td
                        style={{
                          fmaxWidth: "15%",
                          ontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.finalDate}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.status}
                      </td>
                      <td style={{ width: "30%", paddingLeft: "15px" }}>
                        {props.view !== "client" ? (
                          <button
                            style={{
                              width: "35%",
                              backgroundColor: "#a5bea4",
                              color: "white",
                              borderColor: "white",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={handleShowTaskPopUp}
                          >
                            {"Pokaż zadanie"}
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const taskDataMobile = (
    <>
      {sellTasks.length === 0 ? (
        <>Brak zadań dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Zadanie
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data wykonania
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                ></th>
              </tr>
              {sellTasks
                .sort((a, b) => new Date(b.addDate) - new Date(a.addDate))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.task}
                      </td>

                      <td
                        style={{
                          fmaxWidth: "15%",
                          ontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.finalDate}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.status}
                      </td>
                      <td style={{ width: "30%" }}>
                        {props.view !== "client" ? (
                          <button
                            style={{
                              width: "100%",
                              backgroundColor: "#a5bea4",
                              color: "white",
                              borderColor: "white",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={handleShowTaskPopUp}
                          >
                            {"Pokaż zadanie"}
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const logsData = (
    <>
      {sellLogs.length === 0 ? (
        <>Brak logów dla tej sprawy</>
      ) : (
        <>
          <div style={{ marginBottom: "3vh", width: "30%" }}>
            <select
              style={{ height: "3vh" }}
              type="text"
              id="court"
              name="court"
              value={logUserFilter}
              onChange={(e) => setLogUserFilter(e.target.value)}
            >
              <option key={0} value="all">
                Wszyscy
              </option>
              {logUsers.map((el) => (
                <>
                  <option key={el} value={el}>
                    {el}
                  </option>
                </>
              ))}
            </select>
          </div>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Pracownik
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Akcja
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data
                </th>
              </tr>
              {sellLogs
                .filter((el) =>
                  logUserFilter === "all" ? true : el.employee === logUserFilter
                )
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.employee}
                      </td>
                      <td
                        style={{
                          maxWidth: "80%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.value}
                      </td>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate())}{" "}
                        {(new Date(el.date).getHours() < 10
                          ? "0" + new Date(el.date).getHours()
                          : new Date(el.date).getHours()) +
                          ":" +
                          (new Date(el.date).getMinutes() < 10
                            ? "0" + new Date(el.date).getMinutes()
                            : new Date(el.date).getMinutes())}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const logsDataMobile = (
    <>
      {sellLogs.length === 0 ? (
        <>Brak logów dla tej sprawy</>
      ) : (
        <>
          <div style={{ marginBottom: "3vh", width: "100%" }}>
            <select
              style={{ height: "3vh" }}
              type="text"
              id="court"
              name="court"
              value={logUserFilter}
              onChange={(e) => setLogUserFilter(e.target.value)}
            >
              <option key={0} value="all">
                Wszyscy
              </option>
              {logUsers.map((el) => (
                <>
                  <option key={el} value={el}>
                    {el}
                  </option>
                </>
              ))}
            </select>
          </div>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Pracownik
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Akcja
                </th>
                <th
                  style={{
                    fontSize: "3vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data
                </th>
              </tr>
              {sellLogs
                .filter((el) =>
                  logUserFilter === "all" ? true : el.employee === logUserFilter
                )
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.employee}
                      </td>
                      <td
                        style={{
                          maxWidth: "70%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.value}
                      </td>
                      <td
                        style={{
                          maxWidth: "20%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate())}{" "}
                        {(new Date(el.date).getHours() < 10
                          ? "0" + new Date(el.date).getHours()
                          : new Date(el.date).getHours()) +
                          ":" +
                          (new Date(el.date).getMinutes() < 10
                            ? "0" + new Date(el.date).getMinutes()
                            : new Date(el.date).getMinutes())}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const noteData = (
    <>
      {sellNote.length === 0 ? (
        <>Brak notatek dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Pracownik
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Notatka
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data
                </th>
              </tr>
              {sellNote
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.addUser}
                      </td>
                      <td
                        style={{
                          maxWidth: "80%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.content}
                      </td>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.addDate).getFullYear() +
                          "-" +
                          (new Date(el.addDate).getMonth() + 1 < 10
                            ? "0" + (new Date(el.addDate).getMonth() + 1)
                            : new Date(el.addDate).getMonth() + 1) +
                          "-" +
                          (new Date(el.addDate).getDate() < 10
                            ? "0" + new Date(el.addDate).getDate()
                            : new Date(el.addDate).getDate())}{" "}
                        {(new Date(el.addDate).getHours() < 10
                          ? "0" + new Date(el.addDate).getHours()
                          : new Date(el.addDate).getHours()) +
                          ":" +
                          (new Date(el.addDate).getMinutes() < 10
                            ? "0" + new Date(el.addDate).getMinutes()
                            : new Date(el.addDate).getMinutes())}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const deleteFile = async (e) => {
    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSellFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "plik",
    }).then((result) => {
      props.logLeadAction("Usunięto plik", lead.id);
      getData();
    });
  };

  const changeFileNameK = async (e) => {
    MySwal.fire({
      title: "Wprowadź nazwę pliku",
      input: "text",
      inputPlaceholder: "Nazwa pliku",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (true) {
            resolve();
          } else {
            resolve("musisz wprowadzić nazwę pliku");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body4 = {
          id: e.target.value,
          name: result.value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/setSellFileName", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body4),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("download", filename);
    link.setAttribute("target", "_blank");
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile = (e) => {
    var file = sellFiles.filter((el) => el.id === +e.target.value)[0];
    download(file.link, file.name);
  };

  const downloadAll = () => {
    setLoading(true);
    var count = 0;
    sellFiles.forEach(function (file) {
      var filename = file.name + "." + file.link.split(".").pop();
      // loading a file and add it in a zip file
      JSZipUtils.getBinaryContent(file.link, function (err, data) {
        if (err) {
          throw err; // or handle the error
        }
        zip.file(filename, data, { binary: true });
        count++;
        if (count == sellFiles.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, lead.name + ".zip");
          });
        }
      });
    });
    getData();
  };

  const downloadAnalysis = (e) => {
    var file = analysis.filter((el) => el.id === +e.target.value)[0];
    download(file.link, "analiza umowy kredytowej");
  };

  const handleSearchFile = (e) => {
    if (e.target.value === "") {
      setSellFiles(sellFilesOri);
    } else {
      setSellFiles(
        sellFilesOri.filter((el) =>
          el.name
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSortDocs = () => {
    if (docSort === "up") {
      setDocSord("down");
      setSellFiles(
        sellFiles.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        })
      );
    }
    if (docSort === "down") {
      setDocSord("up");
      setSellFiles(
        sellFiles.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
      );
    }
  };

  const documentsView2 = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "2vh",
        }}
      >
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("cat")}
        >
          WIDOK KATEGORII
        </button>

        <input
          style={{ width: "30%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"wyszukaj pliki"}
          onChange={handleSearchFile}
        />

        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>
      </div>
      {sellFiles.length > 0 ? (
        <>
          {sellFiles.length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                PLIKI
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles.map((file) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          padding: "5px 20px",
                          height: "3vh",
                          lineBreak: "anywhere",
                        }}
                      >
                        {file.name}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {file.user}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {new Date(file.date).getFullYear() +
                          "-" +
                          (new Date(file.date).getMonth() + 1 < 10
                            ? "0" + (new Date(file.date).getMonth() + 1)
                            : new Date(file.date).getMonth() + 1) +
                          "-" +
                          (new Date(file.date).getDate() < 10
                            ? "0" + new Date(file.date).getDate()
                            : new Date(file.date).getDate())}{" "}
                        {(new Date(file.date).getHours() < 10
                          ? "0" + new Date(file.date).getHours()
                          : new Date(file.date).getHours()) +
                          ":" +
                          (new Date(file.date).getMinutes() < 10
                            ? "0" + new Date(file.date).getMinutes()
                            : new Date(file.date).getMinutes())}
                      </td>
                      <td
                        style={{
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          style={{ fontSize: "0.8vw" }}
                          className="refreshButton"
                          value={file.id}
                          onClick={downloadFile}
                        >
                          pokaż
                        </button>
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={file.id}
                          onClick={deleteFile}
                          style={{ fontSize: "0.8vw" }}
                        >
                          usuń
                        </button>
                        <button
                          style={{ marginLeft: "10px", fontSize: "0.8vw" }}
                          className="refreshButton"
                          value={file.id}
                          onClick={changeFileNameK}
                        >
                          zmień nazwę
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const documentsView = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "2vh",
        }}
      >
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("all")}
        >
          WIDOK BEZ KATEGORII
        </button>

        <input
          style={{ width: "30%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"wyszukaj pliki"}
          onChange={handleSearchFile}
        />

        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>
      </div>
      {sellFiles.length > 0 ? (
        <>
          {sellFiles.filter((el) => el.type === "sell").length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                Pliki w procesie sprzedaży
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles
                  .filter((el) => el.type === "sell")
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name.substring(0, 100)}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.user}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {new Date(file.date).getFullYear() +
                            "-" +
                            (new Date(file.date).getMonth() + 1 < 10
                              ? "0" + (new Date(file.date).getMonth() + 1)
                              : new Date(file.date).getMonth() + 1) +
                            "-" +
                            (new Date(file.date).getDate() < 10
                              ? "0" + new Date(file.date).getDate()
                              : new Date(file.date).getDate())}{" "}
                          {(new Date(file.date).getHours() < 10
                            ? "0" + new Date(file.date).getHours()
                            : new Date(file.date).getHours()) +
                            ":" +
                            (new Date(file.date).getMinutes() < 10
                              ? "0" + new Date(file.date).getMinutes()
                              : new Date(file.date).getMinutes())}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {props.view !== "client" ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFile}
                              >
                                usuń
                              </button>
                              <button
                                style={{ marginLeft: "10px" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
          {sellFiles.filter((el) => el.type === "mail").length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                Załączniki w mailach
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles
                  .filter((el) => el.type === "mail")
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name.substring(0, 100)}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.user}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {new Date(file.date).getFullYear() +
                            "-" +
                            (new Date(file.date).getMonth() + 1 < 10
                              ? "0" + (new Date(file.date).getMonth() + 1)
                              : new Date(file.date).getMonth() + 1) +
                            "-" +
                            (new Date(file.date).getDate() < 10
                              ? "0" + new Date(file.date).getDate()
                              : new Date(file.date).getDate())}{" "}
                          {(new Date(file.date).getHours() < 10
                            ? "0" + new Date(file.date).getHours()
                            : new Date(file.date).getHours()) +
                            ":" +
                            (new Date(file.date).getMinutes() < 10
                              ? "0" + new Date(file.date).getMinutes()
                              : new Date(file.date).getMinutes())}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          <button
                            className="refreshButton"
                            value={file.id}
                            onClick={deleteFile}
                          >
                            usuń
                          </button>
                          <button
                            style={{ marginLeft: "10px" }}
                            className="refreshButton"
                            value={file.id}
                            onClick={changeFileNameK}
                          >
                            zmień nazwę
                          </button>
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
          {sellFiles.filter((el) => el.type === "sellFinish").length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                Pliki w procesie zakładania sprawy
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles
                  .filter((el) => el.type === "sellFinish")
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name.substring(0, 100)}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.user}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {new Date(file.date).getFullYear() +
                            "-" +
                            (new Date(file.date).getMonth() + 1 < 10
                              ? "0" + (new Date(file.date).getMonth() + 1)
                              : new Date(file.date).getMonth() + 1) +
                            "-" +
                            (new Date(file.date).getDate() < 10
                              ? "0" + new Date(file.date).getDate()
                              : new Date(file.date).getDate())}{" "}
                          {(new Date(file.date).getHours() < 10
                            ? "0" + new Date(file.date).getHours()
                            : new Date(file.date).getHours()) +
                            ":" +
                            (new Date(file.date).getMinutes() < 10
                              ? "0" + new Date(file.date).getMinutes()
                              : new Date(file.date).getMinutes())}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {props.view !== "client" ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFile}
                              >
                                usuń
                              </button>
                              <button
                                style={{ marginLeft: "10px" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const documentsViewMobile2 = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "2vh",
        }}
      >
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("cat")}
        >
          WIDOK KATEGORII
        </button>

        <input
          style={{ width: "30%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"wyszukaj pliki"}
          onChange={handleSearchFile}
        />

        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>
      </div>
      {sellFiles.length > 0 ? (
        <>
          {sellFiles.length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "4vw" }}>
                Pliki
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th style={{ fontSize: "3vw" }}>Nazwa pliku</th>

                  <th style={{ fontSize: "3vw" }}>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles.map((file) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {file.name.substring(0, 100)}
                      </td>

                      <td
                        style={{
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {file.link.includes("apidevkppp.ftpeople.pl") ? (
                          <>
                            <button
                              className="refreshButton"
                              value={file.id}
                              onClick={downloadFile}
                            >
                              pokaż
                            </button>
                          </>
                        ) : (
                          <>
                            <a
                              style={{ textDecoration: "none" }}
                              className="refreshButton"
                              value={file.id}
                              href={file.link}
                              target="_blank"
                            >
                              pokaż
                            </a>
                          </>
                        )}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {props.view !== "client" ? (
                          <>
                            <button
                              className="refreshButton"
                              value={file.id}
                              onClick={deleteFile}
                            >
                              usuń
                            </button>
                            <button
                              style={{ marginLeft: "10px" }}
                              className="refreshButton"
                              value={file.id}
                              onClick={changeFileNameK}
                            >
                              zmień nazwę
                            </button>{" "}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  </>
                ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const documentsViewMobile = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "2vh",
        }}
      >
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("all")}
        >
          WIDOK BEZ KATEGORII
        </button>

        <input
          style={{ width: "30%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"wyszukaj pliki"}
          onChange={handleSearchFile}
        />

        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>
      </div>
      {sellFiles.length > 0 ? (
        <>
          {sellFiles.filter((el) => el.type === "sell").length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "4vw" }}>
                Pliki w procesie sprzedaży
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th style={{ fontSize: "3vw" }}>Nazwa pliku</th>
                  <th style={{ fontSize: "3vw" }}>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles
                  .filter((el) => el.type === "sell")
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name.substring(0, 100)}
                        </td>

                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{
                                  textDecoration: "none",
                                }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {props.view !== "client" ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFile}
                              >
                                usuń
                              </button>
                              <button
                                style={{ marginLeft: "10px" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
          {sellFiles.filter((el) => el.type === "mail").length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "4vw" }}>
                Załączniki w mailach
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th style={{ fontSize: "3vw" }}>Nazwa pliku</th>
                  <th style={{ fontSize: "3vw" }}>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles
                  .filter((el) => el.type === "mail")
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name.substring(0, 100)}
                        </td>

                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          <button
                            className="refreshButton"
                            value={file.id}
                            onClick={deleteFile}
                          >
                            usuń
                          </button>
                          <button
                            style={{ marginLeft: "10px" }}
                            className="refreshButton"
                            value={file.id}
                            onClick={changeFileNameK}
                          >
                            zmień nazwę
                          </button>
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
          {sellFiles.filter((el) => el.type === "sellFinish").length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "4vw" }}>
                Pliki w procesie zakładania sprawy
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th style={{ fontSize: "3vw" }}>Nazwa pliku</th>

                  <th style={{ fontSize: "3vw" }}>Pokaż</th>
                  <th></th>
                </tr>
                {sellFiles
                  .filter((el) => el.type === "sellFinish")
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name.substring(0, 100)}
                        </td>

                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {props.view !== "client" ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFile}
                              >
                                usuń
                              </button>
                              <button
                                style={{ marginLeft: "10px" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const analysisView = (
    <>
      {analysis.sort((a, b) => new Date(b.addDate) - new Date(a.addDate))
        .length > 0 ? (
        <>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th>Data wygenerowania</th>
              <th></th>
            </tr>
            {analysis.map((file) => (
              <>
                <tr>
                  <td
                    style={{
                      width: "30%",
                      padding: "5px 20px",
                      height: "3vh",
                    }}
                  >
                    {file.addDate}
                  </td>

                  <td
                    style={{
                      width: "10%",
                      padding: "5px 20px",
                      height: "3vh",
                    }}
                  >
                    <a
                      style={{
                        textDecoration: "none",
                        fontSize: "1vw !important",
                        padding: "2px 10px",
                      }}
                      className="refreshButton"
                      href={file.link}
                      target="_blank"
                    >
                      pokaż
                    </a>
                  </td>
                </tr>
              </>
            ))}
          </table>
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const analysisViewMobile = (
    <>
      {analysis.sort((a, b) => new Date(b.addDate) - new Date(a.addDate))
        .length > 0 ? (
        <>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th style={{ fontSize: "3vw" }}>Data wygenerowania</th>
              <th></th>
            </tr>
            {analysis.map((file) => (
              <>
                <tr>
                  <td
                    style={{
                      width: "30%",
                      padding: "5px 20px",
                      height: "3vh",
                    }}
                  >
                    {file.addDate}
                  </td>

                  <td
                    style={{
                      width: "10%",
                      padding: "5px 20px",
                      height: "3vh",
                    }}
                  >
                    <a
                      style={{
                        textDecoration: "none",
                        fontSize: "3vw",
                        padding: "2px 10px",
                      }}
                      className="refreshButton"
                      href={file.link}
                      target="_blank"
                    >
                      pokaż
                    </a>
                  </td>
                </tr>
              </>
            ))}
          </table>
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const closeClientContactPopUp = () => {
    setShowClientContact(false);
  };

  const closeAddClientContactPopUp = () => {
    setShowAddClientContact(false);
    getData();
  };

  const closeSendClientMail = (e) => {
    setShowSendClientMail(false);
    getData();
  };

  const closeSendClientSMS = (e) => {
    setShowSendClientSMS(false);
    getData();
  };

  const handleShowSendClientMail = (e) => {
    setShowSendClientMail(true);
  };

  const handleShowSendClientSMS = (e) => {
    setShowSendClientSMS(true);
  };

  const handleShowAddClientContactPopUp = () => {
    setShowAddClientContact(true);
  };

  const deleteLead = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć kontakt?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteLeadAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteLeadAccept = async () => {
    var body = {
      id: lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "kontakt", "success").then((result) => {
      props.close();
    });
  };

  const archivizeLead = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz zarchiwizować kontakt?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        archivizeLeadAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const archivizeLeadAccept = async () => {
    var body = {
      id: lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/archivizeLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Zarchiwizowano", "kontakt", "success").then((result) => {
      props.close();
    });
  };

  const markFinishLead = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz zlecić założenie sprawy?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        markFinishLeadAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const markFinishLeadAccept = async () => {
    var body = {
      id: lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/markFinishLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Zlecono", "założenie sprawy", "success").then((result) => {
      props.close();
    });
  };

  const rekLead = () => {
    MySwal.fire({
      title: "Wprowadź przyczynę reklamacji",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (true) {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        rekLeadAccept(result.value);
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const rekLeadAccept = async (reason) => {
    var body = {
      id: lead.id,
      reason: reason,
    };

    await fetch("https://apidevkppp.ftpeople.pl/rekLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Zareklamowano", "kontakt", "success").then((result) => {
      getData();
    });
  };

  const unarchivizeLead = () => {
    if (props.user.adminSprzedaz === "1") {
      var model = [];
      model[""] = "brak danych";
      users
        .filter((el) => el.sprzedaz === "1")
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (true) {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(async function (result) {
        if (result.isConfirmed) {
          var us = result.value;
          unarchivizeLeadAccept(us);
        }
      });
    } else {
      unarchivizeLeadAccept("");
    }
  };

  const unarchivizeLeadAccept = async (user) => {
    var body = {
      id: lead.id,
      owner: props.user.adminSprzedaz === "1" ? user : props.user.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/unarchivizeLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Przywrócono", "kontakt", "success").then((result) => {
      props.close();
    });
  };

  const unmarkFinishLeadAccept = async (user) => {
    var body = {
      id: lead.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/unmarkFinishLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Anulowano", "zlecenie założenia sprawy", "success").then(
      (result) => {
        props.close();
      }
    );
  };

  const duplicateLeadAcc = () => {
    MySwal.fire({
      title:
        "Czy na pewno chcesz zduplikować kontakt już wcześniej zduplikowany?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        duplicateLead();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const duplicateLead = async (user) => {
    var model = [];
    model["Wybiorę później"] = "Wybiorę później";
    model[""] = "brak danych";
    users
      .filter((el) => el.sprzedaz === "1")
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (true) {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;
        if (result.value === "Wybiorę później") {
          us = "";
        }
        var body = {
          lead: lead,
          owner: us,
        };

        await fetch("https://apidevkppp.ftpeople.pl/duplicateLead", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            MySwal.fire("Zduplikowano", "kontakt", "success").then((result) => {
              emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
              var templateParams = {
                to: users.filter((el) => el.name === us)[0].mail,
                reply_to: props.user.mail,
                user: props.user.name,
                id: lead.id,
                subject: "Nowy kontakt - " + lead.name,
                user_name: props.user.name,
              };

              emailjs.send("KPPP", "template_5knm55c", templateParams).then(
                function (response) {},
                function (error) {
                  MySwal.fire({
                    icon: "error",
                    title: "Błąd",
                    text: "nie wysłano wiadomości e-mail. Ponów operację!",
                  }).then(async (result) => {
                    props.close();
                  });
                }
              );
              props.close();
            });
          })
          .catch((error) => {});
      }
    });
  };

  const closeAddClient = () => {
    setShowAddClient(false);
  };

  const checkEditOption = (option) => {
    if (editOption === "all") {
      return true;
    } else if (option === editOption) {
      return true;
    } else {
      return false;
    }
  };

  const buttons = (
    <>
      {props.view !== "client" ? (
        <>
          {lead.markFinish !== "1" ? (
            <>
              {!loading && props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={deleteLead}
                  >
                    Usuń kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading &&
              lead.archive !== "1" &&
              lead.rek !== "1" &&
              props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "blue",
                      color: "white",
                      borderColor: "white",
                      marginLeft: "15px",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={archivizeLead}
                  >
                    Archiwizuj kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading && (lead.archive === "1" || lead.rek === "1") ? (
                <>
                  <button
                    style={{
                      backgroundColor: "blue",
                      color: "white",
                      borderColor: "white",
                      marginLeft: "15px",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={unarchivizeLead}
                  >
                    Przywróć kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading && props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "gray",
                      color: "white",
                      borderColor: "white",
                      marginLeft: "15px",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={
                      lead.duplicate === "1" ? duplicateLeadAcc : duplicateLead
                    }
                  >
                    Duplikuj kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading &&
              props.user.adminSprzedaz === "1" &&
              lead.rek !== "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      borderColor: "white",
                      marginLeft: "15px",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={rekLead}
                  >
                    Reklamuj kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading &&
              lead.status === "mamy podpisaną umowę o współpracę" &&
              props.user.sprzedazZlecSprawe === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "yellow",
                      color: "black",
                      borderColor: "white",
                      marginLeft: "15px",
                      width: "auto",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={showFinishLeadData}
                  >
                    ZLECENIE ZAŁOŻENIA SPRAWY
                  </button>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </>
  );

  const buttonsMobile = (
    <>
      {props.view !== "client" ? (
        <>
          {lead.markFinish !== "1" ? (
            <>
              {!loading && props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      borderColor: "white",
                      width: "45%",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={deleteLead}
                  >
                    Usuń kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading &&
              lead.archive !== "1" &&
              lead.rek !== "1" &&
              props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "blue",
                      color: "white",
                      borderColor: "white",
                      width: "45%",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={archivizeLead}
                  >
                    Archiwizuj kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading && (lead.archive === "1" || lead.rek === "1") ? (
                <>
                  <button
                    style={{
                      backgroundColor: "blue",
                      color: "white",
                      borderColor: "white",
                      width: "45%",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={unarchivizeLead}
                  >
                    Przywróć kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading && props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "gray",
                      color: "white",
                      borderColor: "white",
                      width: "45%",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={
                      lead.duplicate === "1" ? duplicateLeadAcc : duplicateLead
                    }
                  >
                    Duplikuj kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading &&
              props.user.adminSprzedaz === "1" &&
              lead.rek !== "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      borderColor: "white",
                      width: "45%",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={rekLead}
                  >
                    Reklamuj kontakt
                  </button>
                </>
              ) : (
                ""
              )}
              {!loading &&
              lead.status === "mamy podpisaną umowę o współpracę" &&
              props.user.sprzedazZlecSprawe === "1" ? (
                <>
                  <button
                    style={{
                      backgroundColor: "yellow",
                      color: "black",
                      borderColor: "white",
                      marginLeft: "15px",
                      width: "auto",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={showFinishLeadData}
                  >
                    ZLECENIE ZAŁOŻENIA SPRAWY
                  </button>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      {showFinishLead ? (
        <>
          <FinishLeadFirst
            close={closeFinishLeadData}
            closeS={closeFinishLeadDataS}
            user={props.user ? props.user : props.uData}
            leadData={lead}
            mode="filled"
            logLeadAction={props.logLeadAction}
          />
        </>
      ) : (
        ""
      )}
      {showSellGenerateAnalysis ? (
        <SellGenerateAnalysis
          close={closeGenerateAnalysis}
          logClientAction={props.logLeadAction}
          id={lead.id}
          lead={lead}
          user={props.user ? props.user.name : props.uData.name}
          generateAnalysis={props.generateAnalysis}
        />
      ) : (
        ""
      )}
      {showTaskPopUp ? (
        <>
          <SellTaskPopUp
            close={closeShowTaskPopUp}
            taskId={showTaskPopUpId}
            user={props.user ? props.user : props.uData}
            uData={props.user ? props.user : props.uData}
            logLeadAction={props.logLeadAction}
          />
        </>
      ) : (
        ""
      )}
      {showAddClient ? (
        <AddClient
          clientsSheetData={props.clientsSheetData}
          lawyersData={lawyersData}
          courtsData={courtsData}
          banksData={banksData}
          close={closeAddClient}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          paymentsSheetData={props.paymentsSheetData}
          users={users}
          mode={"lead"}
          editOption={editOption}
          checkEditOption={checkEditOption}
          userRole={props.user ? props.user.role : props.uData.role}
          userMail={props.user ? props.user.mail : props.uData.mail}
          userPhone={props.user ? props.user.phone : props.uData.phone}
          team={0}
          user={props.user ? props.user : props.uData}
          lead={lead}
        />
      ) : (
        ""
      )}
      {!showTaskPopUp && !showSellGenerateAnalysis && !showAddClient ? (
        <>
          <div
            style={{ width: "100%", marginBottom: "1vh" }}
            className="closeBox"
          >
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {loading ? (
            <LoadingPopup />
          ) : (
            <>
              <div className="paymentMenuContainer">
                <span className="client_popup_title">
                  {lead.name}
                  {props.user.adminSprzedaz === "1" && lead.duplicate === "1"
                    ? " - lead zduplikowany"
                    : ""}
                </span>
              </div>
              {props.view !== "client" ? (
                <>
                  <div className="paymentMenuContainer">
                    <button
                      style={{
                        backgroundColor: "orange",
                        color: "black",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowAddTask}
                    >
                      Dodaj zadanie
                    </button>
                    <button
                      style={{
                        backgroundColor: "blue",
                        color: "white",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowAddClientContactPopUp}
                    >
                      Dodaj kontakt
                    </button>
                    {lead.type === "WIBOR" ? (
                      ""
                    ) : (
                      <>
                        <button
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            borderColor: "white",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          onClick={handleShowGenerateAnalysis}
                        >
                          Wygeneruj analizę
                        </button>
                      </>
                    )}

                    <button
                      style={{
                        backgroundColor: "#3d533d",
                        color: "white",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowSendFile}
                    >
                      Dodaj plik
                    </button>
                    <button
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowSendClientMail}
                    >
                      Wysyłka maila
                    </button>
                    <button
                      style={{
                        backgroundColor: "cyan",
                        color: "black",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowSendClientSMS}
                    >
                      Wysyłka sms
                    </button>
                    {props.user.generowanieUmowy ? (
                      <button
                        style={{
                          backgroundColor: "gray",
                          color: "white",
                          borderColor: "white",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        onClick={handleShowAddAggr}
                      >
                        Wygeneruj umowę i pełn.
                      </button>
                    ) : (
                      ""
                    )}
                    {lead.type === "SKD" && lead.skd_ank !== "1" ? (
                      <button
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          borderColor: "white",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        onClick={handleShowSkdAn}
                      >
                        Uzupełnij ankietę leada SKD
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="clientTabsContent">
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                  id="clientsTabPanel"
                >
                  <TabList id="clientsTabPanel_tablist">
                    <Tab>
                      <span className="tabTitle">INFORMACJE O LEADZIE</span>
                    </Tab>
                    <Tab>
                      <span className="tabTitle">DANE KREDYTU</span>
                    </Tab>
                    <Tab>
                      <span className="tabTitle">KONTAKTY</span>
                    </Tab>
                    <Tab>
                      <span className="tabTitle">ZADANIA</span>
                    </Tab>
                    <Tab>
                      <span className="tabTitle">HISTORIA</span>
                    </Tab>
                    {lead.type === "WIBOR" ? (
                      ""
                    ) : (
                      <Tab>
                        <span className="tabTitle">ANALIZY</span>
                      </Tab>
                    )}
                    <Tab>
                      <span className="tabTitle">DOKUMENTY</span>
                    </Tab>
                  </TabList>

                  <TabPanel>
                    <div className="tabContent">
                      <div className="desktopFilters">{leadData}</div>
                      <div className="mobileFilters">{leadDataMobile}</div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="tabContent">
                      <div className="desktopFilters">{creditData}</div>
                      <div className="mobileFilters">{creditDataMobile}</div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="tabContent">
                      <div className="desktopFilters">{sellContactData}</div>
                      <div className="mobileFilters">
                        {sellContactDataMobile}
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="tabContent">
                      <div className="desktopFilters">{taskData}</div>
                      <div className="mobileFilters">{taskDataMobile}</div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="tabContent">
                      <div className="desktopFilters">{logsData}</div>
                      <div className="mobileFilters">{logsDataMobile}</div>
                    </div>
                  </TabPanel>
                  {lead.type === "WIBOR" ? (
                    ""
                  ) : (
                    <TabPanel>
                      <div className="tabContent">
                        <div className="desktopFilters">{analysisView}</div>
                        <div className="mobileFilters">
                          {analysisViewMobile}
                        </div>
                      </div>
                    </TabPanel>
                  )}
                  <TabPanel>
                    <div className="tabContent">
                      <div className="desktopFilters">
                        {docMode === "cat" ? documentsView : documentsView2}
                      </div>
                      <div className="mobileFilters">
                        {docMode === "cat"
                          ? documentsViewMobile
                          : documentsViewMobile2}
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>

              <div className="desktopFilters">{buttons}</div>
              <div className="mobileFilters">
                <div className="buttLead">{buttonsMobile}</div>
              </div>

              {showAddFile ? (
                <AddSellFile
                  close={closeSendFile}
                  logClientAction={props.logLeadAction}
                  id={lead.id}
                  tasks={sellTasks}
                  lead={lead}
                  user={props.user.name ? props.user.name : props.uData.name}
                  userMail={
                    props.user.mail ? props.user.mail : props.uData.mail
                  }
                  userPhone={
                    props.user.phone ? props.user.phone : props.uData.phone
                  }
                  uData={props.user}
                  owner={lead.owner}
                />
              ) : (
                ""
              )}
              {showNotePopUp ? (
                <>
                  <NotePopUp
                    content={noteContent}
                    closePopUp={handleCloseNote}
                    type={"note"}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadTask ? (
                <AddSellTask
                  close={closeAddTask}
                  logClientAction={props.logLeadAction}
                  leadData={lead}
                  user={props.user ? props.user.name : props.uData.name}
                  uData={props.user ? props.user : props.uData}
                />
              ) : (
                ""
              )}
              {showAddLeadNote ? (
                <AddLeadNoteSmall
                  close={closeAddLeadNote}
                  logClientAction={props.logLeadAction}
                  leadData={lead}
                  user={props.user ? props.user.name : props.uData.name}
                />
              ) : (
                ""
              )}
              {showAddClientContact ? (
                <AddSellClientContactPopUp
                  close={closeAddClientContactPopUp}
                  leadData={lead}
                  logClientAction={props.logLeadAction}
                  user={props.uData ? props.uData : props.user}
                  uData={props.uData}
                />
              ) : (
                ""
              )}
              {showSendClientMail ? (
                <SendSellClientMail
                  close={closeSendClientMail}
                  leadData={lead}
                  logClientAction={props.logLeadAction}
                  userMail={props.uData ? props.uData.mail : props.user.mail}
                  userName={props.uData ? props.uData.name : props.user.name}
                  usePhone={props.uData ? props.uData.phone : props.user.phone}
                  uData={props.uData ? props.uData : props.user}
                />
              ) : (
                ""
              )}
              {showSendClientSMS ? (
                <SendSellClientSMS
                  close={closeSendClientSMS}
                  leadData={lead}
                  logClientAction={props.logLeadAction}
                  userMail={props.uData ? props.uData.mail : props.user.mail}
                  userName={props.uData ? props.uData.name : props.user.name}
                  userPhone={props.uData ? props.uData.phone : props.user.phone}
                  uData={props.uData ? props.uData : props.user}
                />
              ) : (
                ""
              )}
              {showClientContact ? (
                <>
                  <ClientContactPopUp
                    contactId={contactId}
                    close={closeClientContactPopUp}
                    contactsData={sellContacts}
                    clientName={lead.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadName ? (
                <>
                  <EditLeadName
                    leadData={lead}
                    close={closeEditLeadName}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadType ? (
                <>
                  <EditLeadType
                    leadData={lead}
                    close={closeEditLeadType}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                    files={sellFiles.length === 0 ? "blank" : "noblank"}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadFut ? (
                <>
                  <EditLeadFut
                    leadData={lead}
                    close={closeLeadFut}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadDecAgg ? (
                <>
                  <EditLeadDecAgg
                    leadData={lead}
                    close={closeLeadDecAgg}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadPhone ? (
                <>
                  <EditLeadPhone
                    leadData={lead}
                    close={closeEditLeadPhone}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadMail ? (
                <>
                  <EditLeadMail
                    leadData={lead}
                    close={closeEditLeadMail}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showAddAggr ? (
                <>
                  <AddAggr
                    leadData={lead}
                    close={closeAddAggr}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showSkdAn ? (
                <>
                  <AnSKD
                    leadData={lead}
                    close={closeAddSkdAn}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadBank ? (
                <>
                  <EditLeadBank
                    leadData={lead}
                    close={closeEditLeadBank}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadSource ? (
                <>
                  <EditLeadSource
                    leadData={lead}
                    close={closeEditLeadSource}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadRealSource ? (
                <>
                  <EditLeadRealSource
                    leadData={lead}
                    close={closeEditLeadRealSource}
                    user={props.user ? props.user.name : props.uData}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadOwner ? (
                <>
                  <EditLeadOwner
                    leadData={lead}
                    close={closeEditLeadOwner}
                    user={props.user.name}
                    uData={props.user ? props.user : props.uData}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadSupport ? (
                <>
                  <EditLeadSupport
                    leadData={lead}
                    close={closeEditLeadSupport}
                    user={props.user.name}
                    uData={props.user ? props.user : props.uData}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showLeadSupportLawyer ? (
                <>
                  <EditLeadSupportLawyer
                    leadData={lead}
                    close={closeEditLeadSupportLawyer}
                    user={props.user.name}
                    uData={props.user ? props.user : props.uData}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadStatus ? (
                <>
                  <EditLeadStatus
                    leadData={lead}
                    leadContactData={
                      sellContacts.filter((el) =>
                        el.type.includes("Telefoniczny")
                      ).length
                    }
                    close={closeEditLeadStatus}
                    closeFull={closeEditLeadStatusFull}
                    user={props.user ? props.user.name : props.uData.name}
                    uData={props.user ? props.user : props.uData}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
              {showEditLeadCreditData ? (
                <>
                  <EditLeadCreditData
                    leadData={lead}
                    close={closeEditLeadCreditData}
                    user={props.user ? props.user.name : props.uData.name}
                    logClientAction={props.logLeadAction}
                  />
                </>
              ) : (
                ""
              )}
            </>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default LeadPopUp;
